import { createFileRoute } from '@tanstack/react-router';
import { HStack, Spacer } from '@/components/Layout';
import InnerNavigation from './-components/InnerNavigation';
import { PlaceForm } from './-components/PlaceForm';
import { ProgressCard } from './-components/ProgressCard';
import { AddPlaceFormStore } from './-form/add-place-form-store';
export const Route = createFileRoute('/_staff/places/add/')({
  component: PlaceAdd
});
function PlaceAdd() {
  const store = AddPlaceFormStore.createStore();
  return <AddPlaceFormStore.Provider value={store}>
      <HStack className="w-full p-6">
        <InnerNavigation />
        <Spacer variant="m" />
        <PlaceForm className="grow min-w-[340px]" />
        <Spacer variant="m" />
        <ProgressCard />
      </HStack>
    </AddPlaceFormStore.Provider>;
}